export default __webpack_public_path__ + "static/media/640_store03-jp-mobile.8379f1aa.png";